import { useEffect, useState } from 'react';
import device from '@/client/utils/device';

interface Client {
  isInSnack: boolean;
  isIos: boolean;
}

const useClient = (): Client => {
  const [client, setClient] = useState<Client>({ isInSnack: true, isIos: false });

  useEffect(() => {
    setClient({
      isInSnack: device.isInSnack(),
      isIos: device.isIos(),
    });
  }, []);

  return client;
};

export default useClient;
